<script>
    import { http } from '@/system/http';
    import forEach from 'lodash/forEach';
    import CalendarsSelect from "../global/form/CalendarsSelect";
    import SendableSmsInput from "../settings/sendables/SendableSmsInput";

    export default {
        components: {
            CalendarsSelect,
            SendableSmsInput,
        },

        props: {
            visible: {
                type: Boolean,
                default: false
            },
            selectedDate: {
                type: String,
                default: ''
            },
        },
        

        data() {
            return {
                calendars: [],
                smsContent: {
                    content: '',
                    tags: [],
                },
                loading: false,
                errorBag: [],
                escKeyHandler: null,
            }
        },

        beforeUnmount() {
            this.removeEscListener();
        },

        methods: {
            submit() {
                this.loading = true;
                const calendarIds = this.calendars.map(calendar => calendar.id);

                http.post('/app/calendar/send-bulk-sms', {
                    calendarIds: calendarIds,
                    content: this.smsContent.content,
                    selectedDate: this.selectedDate,
                })
                .catch((error) => {
                    this.errorBag = error.errorBag.items;
                    return Promise.reject(error);
                })
                .then((response) => {
                    this.closeModal();
                    toastr.success(response.data.success);
                }).finally(() => {
                    this.loading = false;
                });
            },

            assignEscListener() {
                this.escKeyHandler = (evt) => {
                    if (evt.keyCode === 27) {
                        this.closeModal();
                    }
                }
                document.addEventListener('keyup', this.escKeyHandler);
            },

            removeEscListener() {
                if (this.escKeyHandler) {
                    document.removeEventListener('keyup', this.escKeyHandler);
                    this.escKeyHandler = null;
                }
            },

            closeModal() {
                this.errorBag = [];
                this.smsContent.content = '';
                this.$emit('close');
                $('#bulk-sms-bookings-modal').modal('hide');
            },
        },

        watch: {
            visible: function (val) {
                if (!val) {
                    this.removeEscListener();
                    this.calendars = [];
                    return;
                }

                this.assignEscListener()

                this.calendars = this.$store.getters['calendars/getCalendars']();

                $('#bulk-sms-bookings-modal').modal('show');
            }
        },
    };
</script>

<template>
    <div id="bulk-sms-bookings-modal" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog">

            <div class="m-0 panel panel-color panel-inverse">
                <div class="panel-heading">
                    <button type="button" class="close" aria-hidden="true" @click="closeModal">×</button>
                    <h3 class="truncate panel-title"><i class="zmdi zmdi-calendar-close m-r-10"></i>{{ trans('calendar.bulk_sms_title') }}</h3>
                </div>
            </div>

            <div class="modal-content flex flex-col">

                <div class="p-10">
                    <SendableSmsInput
                        v-model="smsContent"
                        :simple="true"
                    />
                </div>

                <div v-if="errorBag.length" class="p-10">
                    <div class="alert alert-danger" role="alert">
                        <p v-for="error in errorBag" :key="error.msg">{{ error.msg }}</p>
                    </div>
                </div>

                <div class="form-group col-xs-12 col-sm-12">
                    <label class="control-label">{{ trans('global.calendars') }}</label>
                    <calendars-select
                        :data-placeholder="trans('calendar.create_client_label_choose_calendar')"
                        v-model="calendars"
                    ></calendars-select>
                </div>

                <div class="modal-footer">
                    <button @click="submit" class="btn btn-custom" :disabled="loading" :loading="loading">{{ trans('calendar.send') }}</button>
                </div>

            </div>

        </div>
    </div>
</template>
